import React from 'react';
import { Users, Calendar, Newspaper, Award } from 'lucide-react';

const iconMap = {
  calendar: Calendar,
  newspaper: Newspaper,
  users: Users,
  award: Award,
};

const AboutSection = ({ data }) => {
  const features = data?.features || [];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {data?.section_title?.split("NYC's")[0] || "Your Gateway to"}
            <span className="block text-gray-900">
              {data?.section_title?.includes("NYC") ? "NYC's Tech Ecosystem" : data?.section_title || "NYC's Tech Ecosystem"}
            </span>
          </h2>
          <div 
            className="text-xl text-gray-600 max-w-3xl mx-auto [&>p]:mb-2 [&>b]:font-semibold [&>strong]:font-semibold [&>i]:italic [&>em]:italic [&>a]:text-gray-600 [&>a]:underline [&>a:hover]:text-gray-400 [&>h1]:text-4xl [&>h1]:font-extrabold [&>h1]:mb-3 [&>h1]:text-gray-900 [&>h2]:text-3xl [&>h2]:font-bold [&>h2]:mb-3 [&>h2]:text-gray-900 [&>h3]:text-2xl [&>h3]:font-bold [&>h3]:mb-2 [&>h3]:text-gray-800 [&>h4]:text-xl [&>h4]:font-semibold [&>h4]:mb-2 [&>h4]:text-gray-800 [&>h5]:text-lg [&>h5]:font-medium [&>h5]:mb-2 [&>h5]:text-gray-700 [&>h6]:text-base [&>h6]:font-medium [&>h6]:mb-1 [&>h6]:text-gray-700 [&>ul]:list-disc [&>ul]:ml-6 [&>ul]:mb-2 [&>ol]:list-decimal [&>ol]:ml-6 [&>ol]:mb-2 [&>li]:mb-1"
            dangerouslySetInnerHTML={{ __html: data?.section_description || "At Pulse NYC, we're your go-to source for the latest developments in technology." }}
          />
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
          {features.map((feature, index) => {
            const Icon = iconMap[feature.icon] || Calendar;
            return (
              <div
                key={index}
                className="group p-8 rounded-2xl bg-gradient-to-br from-gray-50 to-white border border-gray-200 hover:border-gray-300 hover:shadow-xl transition-all duration-300"
              >
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 rounded-xl bg-gray-100 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <Icon className="text-gray-900" size={24} />
                    </div>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
